// APP
export const APP_LOADING = "APP_LOADING";
export const APP_SUCCESS = "APP_SUCCESS";
export const APP_ERROR = "APP_ERROR";

//onboarding-step1 Account
export const REGISTER_ACCOUNT_SUCCESS = "REGISTER_ACCOUNT_SUCCESS";
export const REGISTER_ACCOUNT_ERROR = "REGISTER_ACCOUNT_ERROR";

//validate phone
export const VALIDATE_PHONE_SUCCESS = "VALIDATE_PHONE_SUCCESS";
export const VALIDATE_PHONE_ERROR = "VALIDATE_PHONE_ERROR";

//validate Account
export const VALIDATE_ACCOUNT_SUCCESS = "VALIDATE_ACCOUNT_SUCCESS";
export const VALIDATE_ACCOUNT_ERROR = "VALIDATE_ACCOUNT_ERROR";

//validate tenant name
export const VALIDATE_TENANT_NAME_SUCCESS = "VALIDATE_TENANT_NAME_SUCCESS";
export const VALIDATE_TENANT_NAME_ERROR = "VALIDATE_TENANT_NAME_ERROR";

//get list countries
export const LIST_COUNTRIES_SUCCESS = "LIST_COUNTRIES_SUCCESS";
export const LIST_COUNTRIES_ERROR = "LIST_COUNTRIES_ERROR";

//get list time zone by country code
export const LIST_TIMEZONE_SUCCESS = "LIST_TIMEZONE_SUCCESS";
export const LIST_TIMEZONE_ERROR = "LIST_TIMEZONE_ERROR";

//get list languages supported
export const LIST_LANGUAGES_SUCCESS = "LIST_LANGUAGES_SUCCESS";
export const LIST_LANGUAGES_ERROR = "LIST_LANGUAGES_ERROR";

//get list industries by language id
export const LIST_INDUSTRIES_SUCCESS = "LIST_INDUSTRIES_SUCCESS";
export const LIST_INDUSTRIES_ERROR = "LIST_INDUSTRIES_ERROR";

//get list profiles by language id
export const LIST_PROFILES_SUCCESS = "LIST_PROFILES_SUCCESS";
export const LIST_PROFILES_ERROR = "LIST_PROFILES_ERROR";

//get list job roles by language id
export const LIST_ROLES_SUCCESS = "LIST_ROLES_SUCCESS";
export const LIST_ROLES_ERROR = "LIST_ROLES_ERROR";

//set language global app
export const SET_LANGUAGE = "SET_LANGUAGE"

//validate emails public
export const VALIDATE_EMAIL_PUBLIC_SUCCESSS = "VALIDATE_EMAIL_PUBLIC_SUCCESSS";
export const VALIDATE_EMAIL_PUBLIC_ERROR = "VALIDATE_EMAIL_PUBLIC_ERROR";